import { Controller } from "@hotwired/stimulus"

// Toggles a 3D flip on click / keyboard activation.
//
// <div data-controller="flip-card" class="flip-card">
//   <div data-flip-card-target="inner" class="flip-card__inner">
//     <div class="flip-card__face flip-card__face--front">...</div>
//     <div class="flip-card__face flip-card__face--back">...</div>
//   </div>
// </div>
export default class extends Controller {
  static targets = ["inner"]
  static classes = ["flipped"]

  connect() {
    this.flipped = false
    // Allow keyboard activation
    this.element.setAttribute("tabindex", "0")
    this.element.setAttribute("role", "button")
    this.element.setAttribute("aria-pressed", "false")
  }

  toggle(event) {
    // Don't trigger when the user is interacting with a link/button inside.
    if (event.target.closest("a, button")) return
    this.flipped = !this.flipped
    this.innerTarget.classList.toggle("is-flipped", this.flipped)
    this.element.setAttribute("aria-pressed", this.flipped ? "true" : "false")
  }

  keytoggle(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      this.toggle(event)
    }
  }
}
